import { createContext, useContext, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import { PoliticalPartyCreateEditState, PoliticalPartyCreateEditReducer, ACTION_TYPES } from './political-party-create-edit-reducer';
export { ACTION_TYPES };

const PoliticalPartyCreateEditContext = createContext<PoliticalPartyCreateEditState | undefined>(undefined);
const PoliticalPartyCreateEditDispatchContext = createContext({} as any);

export const PoliticalPartyCreateEditProvider = ({ children }: { children: React.ReactNode }) => {
    const { partyId } = useParams();

    const initialState: PoliticalPartyCreateEditState = {
        partyId,
        partyRequest: { isActive: true },
        showValidationErrors: false,
    };

    const [state, dispatch] = useReducer(PoliticalPartyCreateEditReducer, initialState);

    return (
        <PoliticalPartyCreateEditContext.Provider value={state}>
            <PoliticalPartyCreateEditDispatchContext.Provider value={dispatch}>
                {children}
            </PoliticalPartyCreateEditDispatchContext.Provider>
        </PoliticalPartyCreateEditContext.Provider>
    );
};

export const usePoliticalPartyCreateEditState = () => {
    const context = useContext(PoliticalPartyCreateEditContext);
    if (context === undefined) throw new Error('usePoliticalPartyCreateEditState must be used within PoliticalPartyCreateEditProvider');
    return context;
};

export const usePoliticalPartyCreateEditDispatch = () => {
    const context = useContext(PoliticalPartyCreateEditDispatchContext);
    if (context === undefined) throw new Error('usePoliticalPartyCreateEditDispatch must be used within PoliticalPartyCreateEditProvider');
    return context;
};
